__turbopack_context__.v({
  "html": "Html-module__VnMY8q__html",
  "theme": "Html-module__VnMY8q__theme",
});
